import React from 'react'
import type {ContentTextWidgetItem} from 'src/api/types'
import {isAuthMode, isMarketIntegration} from 'src/shared/config'

import {TextItem} from '../text-item'
import * as classes from './TextWidget.classes'

type Props = {
  item: ContentTextWidgetItem
}

const alignmentMap = {
  lead: classes.textLeft,
  center: classes.textCenter,
  trail: classes.textRight,
} as const

export const TextWidget: React.FC<Props> = ({item}) => {
  // Приоритет 1: auth режим → ПОКАЗАТЬ код выдачи
  if (isAuthMode) {
    return renderWidget(item)
  }

  // Приоритет 2: legacy integration (referer/user-agent) → НЕ ПОКАЗЫВАТЬ
  if (isMarketIntegration) {
    return null
  }

  // Обычная шарилка → НЕ ПОКАЗЫВАТЬ
  return null
}

function renderWidget(item: ContentTextWidgetItem) {
  const {title, subtitle, title_alignment, subtitle_alignment} = item

  const titleAlignmentClass = title_alignment ? alignmentMap[title_alignment] : classes.textCenter
  const subtitleAlignmentClass = subtitle_alignment ? alignmentMap[subtitle_alignment] : classes.textCenter

  return (
    <div className={classes.container}>
      <div className={titleAlignmentClass}>
        <TextItem item={title} />
      </div>
      {subtitle && (
        <div className={subtitleAlignmentClass}>
          <TextItem item={subtitle} />
        </div>
      )}
    </div>
  )
}
